module.exports = __webpack_public_path__ + "img/brazil.81de4580.svg";